"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dictionary = _interopRequireDefault(require("./dictionary"));
var _types = require("./types");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// !TODO: put this back

// Pads with zeros on the left if it's a single digit number
const pad = function (number) {
  let segmentWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return String(number).padStart(segmentWidth, '0');
};
const Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "Segment__Container",
  componentId: "components-web__sc-yrh35y-0"
})(_ref => {
  let {
    segmentFontSize,
    segmentWidth = 2,
    variant: {
      feature
    }
  } = _ref;
  return {
    justifyContent: 'space-evenly',
    display: 'inline-flex',
    ...(feature && {
      // This is required because when the numbers for Countdown change, the character widths will change and thereby effecting the container demensions.
      width: `${segmentFontSize * _constants.SEGMENT_WIDTH_TO_FONT_SIZE_RATIO * segmentWidth}px`,
      display: 'flex'
    })
  };
});
// A segment of the countdown string: we need to make sure it
// keeps its width constant to prevent the whole component from
// being automatically resized while using variable size fonts
const Segment = /*#__PURE__*/_react.default.forwardRef((_ref2, ref) => {
  let {
    copy = 'en',
    segmentFontSize,
    labelKey,
    labelTokens,
    number,
    numberTokens,
    labelMediaIds,
    mainTextMediaIds,
    segmentWidth = 2,
    variant = {}
  } = _ref2;
  const getCopy = (0, _componentsBase.useCopy)({
    dictionary: _dictionary.default,
    copy
  });
  const {
    label,
    large,
    feature
  } = variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Container, {
    segmentFontSize: segmentFontSize,
    segmentWidth: segmentWidth,
    variant: variant,
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_componentsBase.StackView, {
      direction: large || feature ? 'column' : 'row',
      space: large || feature ? 0 : 1,
      tokens: {
        alignItems: 'center'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        tokens: numberTokens,
        media: mainTextMediaIds,
        dataSet: {
          chromatic: labelKey === 'second' ? 'ignore' : undefined
        },
        children: pad(number, segmentWidth)
      }), label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentsBase.Typography, {
        tokens: labelTokens,
        media: labelMediaIds,
        children: getCopy(number === 1 ? labelKey : `${labelKey}s`)
      })]
    })
  });
});
Segment.displayName = 'Segment';
Segment.propTypes = {
  /**
   * Copy language identifier or a dictionary instance.
   */
  copy: _propTypes.default.oneOfType([_propTypes.default.oneOf(['en', 'fr']), _types.dictionaryContentShape]),
  segmentFontSize: _propTypes.default.number,
  labelKey: _propTypes.default.oneOf(['day', 'hour', 'minute', 'second']),
  labelTokens: _propTypes.default.object,
  number: _propTypes.default.number,
  numberTokens: _propTypes.default.object,
  segmentWidth: _propTypes.default.number,
  labelMediaIds: _propTypes.default.string,
  mainTextMediaIds: _propTypes.default.string,
  variant: _types.countdownVariantPropType
};
var _default = exports.default = Segment;